module.exports = __webpack_public_path__ + "img/18KW.5cc70477.png";